import { analytics, triggerLogEvent } from "../config/firebase";

import qz from "qz-tray";

export const checkConnection = (business, selected, toggle) => {
    return new Promise((resolve, reject) => {
        if (!qz.websocket.isActive()) {
            qz.websocket
                .connect()
                .then(() => {
                    qz.printers
                        .find()
                        .then((printers) => {
                            if (printers.length) {
                                if (toggle) {
                                    let exist = printers.filter((x) => x === selected);
                                    if (exist.length) resolve(['exist', printers]);
                                    else {
                                        resolve(['not exist', printers])
                                    }
                                } else {
                                    if (business?.printer) {
                                        let exist = printers.filter((x) => x === business?.printer);
                                        if (exist?.length) {
                                            if (business.connected) resolve(['connected', printers]);
                                        } else {
                                            resolve(['not exist', printers]);
                                        }
                                    } else resolve(['not connected', printers]);
                                }
                            }
                            else resolve(printers)
                        })
                        .catch((e) => {
                            triggerLogEvent(analytics, "printer_unable_to_connect");
                            reject('not found');
                        });
                })
                .catch((e) => {
                    triggerLogEvent(analytics, "printer_unable_to_connect");
                    reject('not connected');
                });
        } else {
            qz.printers
                .find()
                .then((printers) => {
                    if (printers.length) {
                        if (toggle) {
                            let exist = printers.filter((x) => x === selected);
                            if (exist.length) resolve(['exist', printers]);
                            else {
                                resolve(['not exist', printers])
                            }
                        } else {
                            if (business?.printer) {
                                let exist = printers.filter((x) => x === business?.printer);
                                if (exist?.length) {
                                    if (business.connected) resolve(['connected', printers]);
                                    else resolve(['off', printers]);
                                } else {
                                    resolve(['not exist', printers]);
                                }
                            } else resolve(['not connected', printers]);
                        }
                    }
                })
                .catch((e) => {
                    triggerLogEvent(analytics, "printer_unable_to_connect");
                    reject('not found');
                });
        }
    })
}